import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AiCard from "../../components/AiCard";
import AiSelectionCard from "../../components/AiSelectionCard";
import MobileViewLayout from "../../layouts/MobileViewLayout";
import { getConversation, getPrevChats } from "../../service/prevChats";
import { aiCardData } from "../../utils/data";
import { formatDateToDayMonth, formatTimeToHourMinute } from "../../utils/date";
import { addS3Url } from "../../utils/modules";

const AiBots = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("Copywriting");

  const changeActiveCategory = (category) => {
    setActiveCategory(category);
  };
  const prevChats = getPrevChats();
  const sortedChats = prevChats.sort(
    (a, b) => new Date(b.time) - new Date(a.time)
  );
  const lastChat = sortedChats[0];
  const currentDate = formatDateToDayMonth();

  const showDate = () => {
    const lastChatDate = new Date(lastChat?.time);
    if (formatDateToDayMonth(lastChatDate) === currentDate) {
      return formatTimeToHourMinute(lastChatDate);
    } else {
      return formatDateToDayMonth(lastChatDate);
    }
  };

  return (
    <MobileViewLayout>
      <div
        style={{
          paddingTop: "20px",
        }}
        className="d-flex flex-column gap-3"
      >
        {lastChat && (
          <>
            <div className="d-flex justify-content-between align-items-center ">
              <p style={{ fontSize: "24px" }} className="fw-bold m-0">
                Continue your last chat
              </p>
              <p
                onClick={() => navigate("allBots")}
                className="m-0 fw-semibold"
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#4286F5",
                  textDecoration: "underline",
                }}
              >
                View all
              </p>
            </div>
            <AiCard
              name={lastChat?.name || "New chat"}
              conversation={
                lastChat?.conversation || getConversation(lastChat?.id)
              }
              chatId={lastChat?.id}
              image={lastChat?.image || addS3Url("/aiBots/01.png")}
              title={lastChat?.title || "New chat"}
              desc={lastChat?.desc || "EmailEngine"}
              time={showDate() || "10:01"}
            />
          </>
        )}
        <p
          style={{ fontSize: "24px", marginTop: "5px" }}
          className="fw-bold mb-0"
        >
          Explore Bots
        </p>
        <div className="d-flex flex-nowrap w-100 overflow-scroll scrollbar-hidden gap-3 ">
          <AiSelectionCard
            title="Copywriting"
            active={activeCategory === "Copywriting"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Content Writing"
            active={activeCategory === "Content Writing"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Inspiration"
            active={activeCategory === "Inspiration"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Analysis"
            active={activeCategory === "Analysis"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Digital Marketing"
            active={activeCategory === "Digital Marketing"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Popular"
            active={activeCategory === "Popular"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Wellness"
            active={activeCategory === "Wellness"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Personal"
            active={activeCategory === "Personal"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Leisure"
            active={activeCategory === "Leisure"}
            changeActiveCategory={changeActiveCategory}
          />
          <AiSelectionCard
            title="Translation"
            active={activeCategory === "Translation"}
            changeActiveCategory={changeActiveCategory}
          />
        </div>
        <div
          className={`card-scroll-container scrollbar-hidden ${
            lastChat ? "" : "height-auto"
          }`}
        >
          {aiCardData[activeCategory]?.map((card) => (
            <AiCard
              key={card.id}
              image={card?.image}
              title={card?.title}
              desc={card?.desc}
            />
          ))}
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default AiBots;
